/**
 * Traduce los filtros de la UI de Auditoría a los `params` que espera
 * `GET /api/audit_logs` (filtros ApiFilter declarados en `AuditLog.php`:
 * actorType/actorId exact, category exact, action partial, entityType/entityId
 * exact, createdAt con DateFilter, order por createdAt).
 */
export const buildAuditLogParams = (filters, page, itemsPerPage) => {
  const params = {
    page,
    itemsPerPage,
    "order[createdAt]": "desc",
  };

  const [startDate, endDate] = filters?.dateRange || [];
  if (startDate) {
    params["createdAt[after]"] = `${startDate}T00:00:00`;
  }
  if (endDate) {
    params["createdAt[before]"] = `${endDate}T23:59:59`;
  }

  if (filters?.category) {
    params.category = filters.category;
  }
  if (filters?.action) {
    params.action = filters.action;
  }
  if (filters?.actorType) {
    params.actorType = filters.actorType;
  }
  if (filters?.actorId) {
    params.actorId = filters.actorId;
  }

  return params;
};
